import { useAuth } from '../contexts/AuthContext';

/**
 * Hook returning true if the current user has the given permission slug.
 * Reads from AuthContext (`permissions` array populated by `me` query).
 */
export function usePermission(permission: string): boolean {
  const { permissions } = useAuth();
  return Array.isArray(permissions) && permissions.includes(permission);
}

/**
 * Hook returning the full list of permissions for the current user.
 */
export function usePermissions(): string[] {
  const { permissions } = useAuth();
  return Array.isArray(permissions) ? permissions : [];
}

/**
 * Hook returning true if the user has ANY of the given permission slugs.
 */
export function useAnyPermission(permissionList: string[]): boolean {
  const { permissions } = useAuth();
  if (!Array.isArray(permissions)) return false;
  return permissionList.some((p) => permissions.includes(p));
}
